import { getCommunicationChartLinkDisplayWeight } from '@web/components/CommunicationNetworkGraph/core/communicationChart/linkTrend';
export var truncateCommunicationChartLabel = function (name, maxLength) {
    if (name.length <= maxLength) {
        return name;
    }
    if (maxLength <= 1) {
        return '…';
    }
    return "".concat(name.slice(0, maxLength - 1), "\u2026");
};
export var computeCommunicationChartNodeDegrees = function (data) {
    var degrees = new Map();
    data.links.forEach(function (link) {
        var _a, _b;
        var weight = getCommunicationChartLinkDisplayWeight(link.stats);
        degrees.set(link.sourceNodeId, ((_a = degrees.get(link.sourceNodeId)) !== null && _a !== void 0 ? _a : 0) + weight);
        degrees.set(link.targetNodeId, ((_b = degrees.get(link.targetNodeId)) !== null && _b !== void 0 ? _b : 0) + weight);
    });
    return degrees;
};
export var getCommunicationChartNodeSize = function (degree, maxDegree, minSize, maxSize) {
    if (maxDegree <= 0) {
        return minSize;
    }
    var ratio = Math.sqrt(degree / maxDegree);
    return Math.round(minSize + ratio * (maxSize - minSize));
};
